import React, { useRef, useState, useEffect, useCallback } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { Swiper as SwiperCore } from 'swiper/types'
import {
  PrevChevron,
  NextChevron
} from '@toasttab/shared/src/components/molecules/SliderNavigation/NavigationIcons'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import VideoCard from '@toasttab/main/src/components/Homepage/Cards/VideoCard'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { VideoCardProps } from '@toasttab/main/src/components/Homepage/Cards/VideoCard.d'

const Customers = ({ header, body }: { header: any; body: any }) => {
  const [prevActive, setPreviousActive] = useState(false)
  const [nextActive, setNextActive] = useState(true)
  const [width, setWidth] = useState<number>(0)

  function handleWindowSizeChange() {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    handleWindowSizeChange()

    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const swiperRef = useRef<SwiperCore>(null)

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (!swiperRef.current) return

      if (e.key === 'ArrowLeft') {
        swiperRef.current.slidePrev()
      } else if (e.key === 'ArrowRight') {
        swiperRef.current.slideNext()
      }
    },
    []
  )

  const iconSize = width < 768 ? 'large' : 'small'

  const prevHeapInteraction = 'hplogos_backarrow_click'
  const nextHeapInteraction = 'hplogos_forwardarrow_click'

  return (
    <section className='mb-10 lg:mb-16 overflow-hidden'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12'>
            <div className='flex flex-col items-center max-w-[46.5rem] mb-10 mx-auto text-center'>
              <img
                alt='Locations'
                className='mb-4 mx-auto w-16 h-16'
                src={resolvePrefix(header.icon)}
              />
              <Typography
                as='h2'
                variation='h2'
                classes='font-effra font-base !leading-[2.5rem] !leading-[3rem] mb-4 !text-[1.938rem] lg:!text-[45px] text-gray-125'
              >
                {header.heading}
              </Typography>
            </div>
            <div
              className='flex lg:justify-center lg:items-center flex-wrap gap-6 mx-auto'
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyDown(e)
              }
              tabIndex={0}
            >
              <Swiper
                modules={[Navigation]}
                speed={300}
                threshold={30}
                grabCursor
                spaceBetween={24}
                a11y={{ enabled: true }}
                loop={false}
                slidesPerView='auto'
                onBeforeInit={(swiper) => {
                  swiperRef.current = swiper
                }}
                onSlideChange={(swiper) => {
                  if (swiper.isEnd) {
                    setNextActive(false)
                  } else {
                    setNextActive(true)
                  }

                  if (swiper.isBeginning) {
                    setPreviousActive(false)
                  } else {
                    setPreviousActive(true)
                  }
                }}
                navigation={{
                  nextEl: '.swiper-next',
                  prevEl: '.swiper-prev'
                }}
                className='swiper-height--full lg:!overflow-visible'
              >
                {body.stories.map((customer: VideoCardProps, i: number) => (
                  <SwiperSlide key={i} className='!w-[264px] !border-box'>
                    <VideoCard {...customer} />
                  </SwiperSlide>
                ))}
                <div className='flex justify-center lg:justify-normal mx-auto mt-10 lg:hidden'>
                  <PrevChevron
                    active={prevActive}
                    size={iconSize}
                    heapInteraction={prevHeapInteraction}
                    classes=' mr-4'
                  />
                  <NextChevron
                    active={nextActive}
                    size={iconSize}
                    heapInteraction={nextHeapInteraction}
                  />
                </div>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Customers
